export default {
  'menu.welcome': 'Willkommen',
  'menu.more-blocks': 'Weitere Blöcke',
  'menu.home': 'Startseite',
  'menu.console': 'Verwaltung',
  'menu.console.sub-page': 'Unterseite',
  'menu.login': 'Anmelden',
  'menu.register': 'Registrieren',
  'menu.register-result': 'Registrierungsergebnis',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analyse',
  'menu.dashboard.monitor': 'Überwachung',
  'menu.dashboard.workplace': 'Arbeitsplatz',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formular',
  'menu.form.basic-form': 'Grundformular',
  'menu.form.step-form': 'Schrittformular',
  'menu.form.step-form.info': 'Schrittformular (Überweisungsinformationen eingeben)',
  'menu.form.step-form.confirm': 'Schrittformular (Überweisungsinformationen bestätigen)',
  'menu.form.step-form.result': 'Schrittformular (abgeschlossen)',
  'menu.form.advanced-form': 'Erweiterte Formulare',
  'menu.list': 'Liste',
  'menu.list.table-list': 'Suchtabelle',
  'menu.list.basic-list': 'Grundliste',
  'menu.list.card-list': 'Kartenliste',
  'menu.list.search-list': 'Suchliste',
  'menu.list.search-list.articles': 'Suchliste (Artikel)',
  'menu.list.search-list.projects': 'Suchliste (Projekte)',
  'menu.list.search-list.applications': 'Suchliste (Anwendungen)',
  'menu.profile': 'Profil',
  'menu.profile.basic': 'Grundprofil',
  'menu.profile.advanced': 'Erweiterte Profile',
  'menu.result': 'Ergebnis',
  'menu.result.success': 'Erfolg',
  'menu.result.fail': 'Fehler',
  'menu.exception': 'Ausnahme',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Auslösen',
  'menu.account': 'Konto',
  'menu.account.center': 'Kontocenter',
  'menu.account.settings': 'Kontoeinstellungen',
  'menu.account.trigger': 'Fehler auslösen',
  'menu.account.logout': 'Abmelden',
  'menu.account.profile': 'Profil',
  'menu.console.agents': 'Agenten',
  'menu.console.agentDevice': 'Agent-Gerät',
  'menu.console.devices': 'Geräte',
  'menu.console.speakers': 'Spracherkennung',
  'menu.console.voiceClone': 'Stimmenklon',
  'menu.console.settings': 'Persönliche Einstellungen',
  'menu.admin': 'Verwaltung',
  'menu.admin.dashboard': 'Dashboard',
  'menu.admin.settings': 'Einstellungen',
  'menu.admin.providers': 'Modellanbieter',
  'menu.admin.unbindDevice': 'Gerät entbinden',
  'menu.admin.userManage': 'Benutzerverwaltung',
  'menu.admin.systemConfig': 'Systemkonfiguration',
  'menu.admin.whiteList': 'Whitelist',
  'menu.admin.opsManage': 'Betrieb',
  'menu.admin.recorderManage': 'Recorder-Verwaltung',
  'menu.admin.deviceManage': 'Geräteverwaltung',

  'menu.console.agentSetting': 'Agent-Einstellungen',
};
